import { render } from "./InstancePropertyInput.vue?vue&type=template&id=702c789c&scoped=true&ts=true"
import script from "./InstancePropertyInput.vue?vue&type=script&lang=ts"
export * from "./InstancePropertyInput.vue?vue&type=script&lang=ts"

import "./InstancePropertyInput.vue?vue&type=style&index=0&id=702c789c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-702c789c"]])

export default __exports__